export default "__VITE_ASSET__D5BQJSfU__"